import classNames from 'classnames';
import React from 'react';

import styles from './index.module.scss';

interface ChatPageContainerProps {
  children: React.ReactNode;
}

const ChatPageContainer: React.FC<ChatPageContainerProps> = ({ children }) => {
  return (
    <div className={classNames('d-flex', styles.chatPageContainer)}>
      {children}
    </div>
  );
};

export default ChatPageContainer;
